/* ToolbarDropdownMenu.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./ToolbarDropdownMenu.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { useCallback } from 'react';
import { cx } from '@compiled/react';
import DropdownMenu from '@atlaskit/dropdown-menu';
import { Box } from '@atlaskit/primitives/compiled';
import { expValEquals } from '@atlaskit/tmp-editor-statsig/exp-val-equals';
import { useToolbarUI } from '../hooks/ui-context';
import { ToolbarButton } from './ToolbarButton';
import { useToolbarDropdownMenu } from './ToolbarDropdownMenuContext';
var styles = {
  sectionMargin: "_1mouv77o",
  firstSectionSeparator: "_18l8n7od",
  scrollContainer: "_c71lnklw _18m91wug"
};
var ToolbarDropdownMenuContent = function ToolbarDropdownMenuContent(_ref) {
  var iconBefore = _ref.iconBefore,
    children = _ref.children,
    isDisabled = _ref.isDisabled,
    testId = _ref.testId,
    label = _ref.label,
    _onClick = _ref.onClick;
  var _useToolbarUI = useToolbarUI(),
    onDropdownOpenChanged = _useToolbarUI.onDropdownOpenChanged;
  var menuContext = useToolbarDropdownMenu();
  var handleOpenChange = useCallback(function (args) {
    onDropdownOpenChanged(args);
    if (!args.isOpen) {
      menuContext === null || menuContext === void 0 || menuContext.closeMenu();
    }
  }, [menuContext, onDropdownOpenChanged]);
  var handleClick = useCallback(function () {
    if (!(menuContext !== null && menuContext !== void 0 && menuContext.isOpen)) {
      menuContext === null || menuContext === void 0 || menuContext.openMenu();
    } else {
      menuContext === null || menuContext === void 0 || menuContext.closeMenu();
    }
  }, [menuContext]);
  return /*#__PURE__*/React.createElement(DropdownMenu, {
    trigger: function trigger(triggerProps) {
      return /*#__PURE__*/React.createElement(ToolbarButton, {
        ref: triggerProps.triggerRef,
        isSelected: triggerProps.isSelected,
        "aria-expanded": triggerProps['aria-expanded'],
        "aria-haspopup": triggerProps['aria-haspopup'],
        "aria-controls": triggerProps['aria-controls'],
        onBlur: triggerProps.onBlur,
        onClick: function onClick(e) {
          _onClick && _onClick(e, !(menuContext !== null && menuContext !== void 0 && menuContext.isOpen));
          handleClick();
          triggerProps.onClick && triggerProps.onClick(e);
        },
        onFocus: triggerProps.onFocus,
        testId: testId,
        iconBefore: iconBefore,
        isDisabled: isDisabled,
        label: label
      });
    },
    onOpenChange: handleOpenChange,
    isOpen: menuContext === null || menuContext === void 0 ? void 0 : menuContext.isOpen
  }, children);
};
export var ToolbarDropdownMenu = function ToolbarDropdownMenu(_ref2) {
  var iconBefore = _ref2.iconBefore,
    children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    testId = _ref2.testId,
    label = _ref2.label,
    _ref2$hasSectionMargi = _ref2.hasSectionMargin,
    hasSectionMargin = _ref2$hasSectionMargi === void 0 ? true : _ref2$hasSectionMargi,
    _ref2$enableMaxHeight = _ref2.enableMaxHeight,
    enableMaxHeight = _ref2$enableMaxHeight === void 0 ? false : _ref2$enableMaxHeight,
    onClick = _ref2.onClick;
  return /*#__PURE__*/React.createElement(ToolbarDropdownMenuContent, {
    iconBefore: iconBefore,
    isDisabled: isDisabled,
    testId: testId,
    label: label,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Box, {
    xcss: cx(hasSectionMargin && styles.sectionMargin, enableMaxHeight && styles.scrollContainer, expValEquals('platform_editor_toolbar_migrate_loom', 'isEnabled', true) && styles.firstSectionSeparator),
    "data-toolbar-component": "menu"
  }, children));
};